var lastScrollTop = 0;
var windowOnChange = 0;


function fullHeightMeatTheTeam(){
    // if (jQuery('.shopify-section.meet-the-team').length){
    //     jQuery('.meet-the-team_section .swiper-coltrols').removeAttr('style');
    //     jQuery('.shopify-section.meet-the-team').removeAttr('style');
    //     let sectionTitleHeight = 0;
    //     let sectionSliderHeight = 0;
    //     if (jQuery('.meet-the-team h6.title').length){
    //         sectionTitleHeight = jQuery('.meet-the-team h6.title').height();
    //     }
    //     if (jQuery('.meet-the-team_section').length){
    //         sectionSliderHeight = jQuery('.meet-the-team_section').outerHeight();
    //     }
    //     let meetPadding = (jQuery(window).height() - sectionTitleHeight - sectionSliderHeight) / 2;
      
    //     jQuery('.meet-the-team_section .swiper-coltrols').css('margin-bottom', meetPadding + 'px');
    //     jQuery('.shopify-section.meet-the-team').css('padding-top', meetPadding + 'px');
    // } 
}


// Header animation when scroll
function showHideHeader(){
    var headerHeight = jQuery('#shopify-section-header').height();
    var st = $(this).scrollTop();
    var scrollUp = false;
     if (st > lastScrollTop){
          scrollUp = false;
     } else {
          scrollUp = true;
     }
     lastScrollTop = st;
      jQuery('#shopify-section-header .header_container').addClass('header-sticky');
    // if (windowOnChange == 0){
        if (sessionStorage.getItem('drawerOpened') == 0 || sessionStorage.getItem('drawerOpened') == null) {
            if (scrollUp) {
                jQuery('#shopify-section-header .header_container').removeClass('header-hide');
            }else{
                if (jQuery(window).scrollTop() > (headerHeight*2)) {
                  jQuery('#shopify-section-header .header_container').addClass('header-hide');
                }else{
                    jQuery('#shopify-section-header .header_container').removeClass('header-hide');
                }
            }
        }
        // if (jQuery(window).scrollTop() > (headerHeight*2)) {
        //     jQuery('#shopify-section-header').addClass('header-sticky');
        // }
    
        // if (jQuery(window).scrollTop() == 0) {
        //     jQuery('#shopify-section-header').removeClass('header-sticky');
        // }
    // }
}


function addSpacingTopMain(){
    if(jQuery('#shopify-section-header').length){
        if (jQuery('.page-science').length == 0 && 
            jQuery('.page-sustainability').length == 0 && 
            jQuery('.t-product').length == 0 && 
            jQuery('.t-index').length == 0
           ){
            jQuery('.main-container').css('margin-top', jQuery('#shopify-section-header').outerHeight()+'px');
        }
    }
}


jQuery(document).ready(function(){
    fullHeightMeatTheTeam();
  
    // Add Navigation button in Review Carousel widget
    jQuery('[data-widget-type="carousel"]').on('DOMNodeInserted',function(){
        jQuery('[data-widget-type="carousel"]:not(.carousel-buttons-added)').each(function(){
            jQuery(this).addClass('carousel-buttons-added');
            var carouselNavButtons = '<div class="carousel-nav-buttons"><div onclick="StampedCarouselFn.switchSlide(this, -1, true)" class="stamped-carousel-button-left"></div><div onclick="StampedCarouselFn.switchSlide(this, 1, true)" class="stamped-carousel-button-right"></div>';
            jQuery(this).find('.stamped-carousel-scroll').append(carouselNavButtons);
        });
    });

    // Move review date in Review Carousel widget
    jQuery('[data-widget-type="carousel"]').on('DOMNodeInserted',function(){
        jQuery(this).find('.stamped-carousel-scroll .block:not(.review-date-moved)').each(function(){   
              if(jQuery(this).find('.stamped-ratings-wrapper > .stamped-reviews-date').length == 0){
                  jQuery(this).addClass('review-date-moved');
                  var reviewDate = jQuery(this).find('.stamped-reviews-date');
                  jQuery(reviewDate).insertAfter(jQuery(this).find('.stamped-reviews-author'));
              }
        });
    });

    showHideHeader();
    addSpacingTopMain();

  
    //Change price in addtocart button
    jQuery('.AddToCartForm').each(function(){
        // if (jQuery(this).closest('.shopify-section').find('.holiday-season-offers').length == 0) {
            let selectedLabel = jQuery(this).find('select option:selected').text();
            let price = jQuery(this).find('select option:selected').attr('data-price');
            // let compare_price = jQuery(this).find('option:selected').attr('data-compare-price');
            // if (compare_price){
            //     jQuery(this).closest('.AddToCartForm').find('.cartButton .price-compare').show();
            //     jQuery(this).closest('.AddToCartForm').find('.cartButton .dash-compare-price').show();
            //     jQuery(this).closest('.AddToCartForm').find('.cartButton .price-compare').text(compare_price);
            // }else{
            //     jQuery(this).closest('.AddToCartForm').find('.cartButton .price-compare').hide();
            //     jQuery(this).closest('.AddToCartForm').find('.cartButton .dash-compare-price').hide();
            // }
            jQuery(this).find('.cartButton .price:not(.manualy)').text(price);
            jQuery(this).find('.cartButton .dash').show();
            jQuery(this).find('.variant-selected .value').text(selectedLabel);
        // }
    });
    jQuery('.AddToCartForm select').change(function(){
        let selectedValue = jQuery(this).val();
        let selectedLabel = jQuery(this).find('option[value="'+selectedValue+'"]').text();
        let price = jQuery(this).find('option[value="'+selectedValue+'"]').attr('data-price');
        // let compare_price = jQuery(this).find('option[value="'+selectedValue+'"]').attr('data-compare-price');
        // if (compare_price){
        //     jQuery(this).closest('.AddToCartForm').find('.cartButton .price-compare').show();
        //     jQuery(this).closest('.AddToCartForm').find('.cartButton .dash-compare-price').show();
        //     jQuery(this).closest('.AddToCartForm').find('.cartButton .price-compare').text(compare_price);
        // }else{
        //     jQuery(this).closest('.AddToCartForm').find('.cartButton .price-compare').hide();
        //     jQuery(this).closest('.AddToCartForm').find('.cartButton .dash-compare-price').hide();
        // }
        jQuery(this).closest('.AddToCartForm').find('.cartButton .price').text(price);
        jQuery(this).closest('.AddToCartForm').find('.cartButton .dash').show();
        jQuery(this).closest('.AddToCartForm').find('.variant-selected .value').text(selectedLabel);
    });

    //Change select option when choose varirant swatch option
    jQuery('.anyway-range-item .swatch-options-container .swatch-option').click(function(){
        jQuery(this).addClass('active').siblings().removeClass('active');
        let selectedValue = jQuery(this).attr('value');
        jQuery(this).closest('.AddToCartForm').find('.select-variants select').val(selectedValue).trigger('change');
    });



    
    if (jQuery('.featured-collection-product form select').length) {
        jQuery('.featured-collection-product form select').each(function(){
            jQuery(this).select2({
                  minimumResultsForSearch: -1,
                  placeholder: "Select a variant",
                  dropdownParent: jQuery(this).parent()
            });
        });
    }
    
    if (jQuery('.featured-product-custom select').length) {
        jQuery('.featured-product-custom select').each(function(){
            jQuery(this).select2({
                minimumResultsForSearch: -1,
                placeholder: "Select a variant",
                dropdownParent: jQuery(this).parent()
            });
        })
          
    }

    
    // jQuery('body').on('click','.AddToCartForm .cartButton[data-button="open-select"]', function(){
    //     jQuery(this).toggleClass('select-open');
    //     if (jQuery(this).closest('.AddToCartForm').find('select option').length == 1 || jQuery(this).closest('.AddToCartForm').find('select option').length == 0){
    //         jQuery(this).closest('.AddToCartForm').find('.cartButton[data-button="not-open-select"]').trigger('click');
    //     }else{
    //         if (jQuery(this).hasClass('select-open') == true){
    //             jQuery(this).closest('.AddToCartForm').find('select').select2('open');
    //         }else{
    //             jQuery(this).closest('.AddToCartForm').find('select').select2('close');
    //         }
    //     }
    // });

    
  
    // jQuery('.AddToCartForm select').on('select2:select', function (e) {
    //     jQuery(this).closest('.AddToCartForm').find('.cartButton[data-button="not-open-select"]').trigger('click');
    //     jQuery(this).closest('.AddToCartForm').find('.cartButton[data-button="open-select"]').removeClass('select-open');
    // });

    // var mouseOverselect = 0;
    // jQuery('.anyway-range-item .AddToCartForm').mouseleave(function(){
    //     mouseOverselect = 0;
    // });
    // jQuery('.anyway-range-item .AddToCartForm').mouseenter(function(){
    //     mouseOverselect = 1;
    // });
           
    jQuery('.AddToCartForm select').on('select2:open', function (e) {
          jQuery(this).closest('.AddToCartForm').find('.variant-selected').addClass('active');
    });
    jQuery('.AddToCartForm select').on('select2:close', function (e) {
          jQuery(this).closest('.AddToCartForm').find('.variant-selected').removeClass('active');
    });
  
     // jQuery('.AddToCartForm .cartButton[data-button="not-open-select"]').on("change", function () {
     //        let buttonClass = jQuery(this).attr('class') + ' open-select ';
     //        jQuery(this).closest('.AddToCartForm').find('.cartButton[data-button="open-select"]').attr('class', buttonClass);
     // });

    //Update minicart total after add to cart
    // jQuery('#shopify-section-header .cart').on('DOMNodeInserted',function(){
    //     console.log('3333333');
    //     if(jQuery('.header_container .cart .qtyinput').length){
    //         var cartTotalNumber = 0;
    //         jQuery('.header_container .cart .qtyinput').each(function(){
    //             if (jQuery(this).text() != 'NaN'){
    //                 cartTotalNumber += parseInt(jQuery(this).text());  
    //             }
                
    //         });

    //         // if (cartTotalNumber == 'NaN'){
    //             // jQuery('.pre-order-header.cart-icon .cart-count').text(0);  
                
    //         // } else {
    //             jQuery('.pre-order-header.cart-icon .cart-count').text(cartTotalNumber);  
    //         // }
            
    //     }else{
    //         if(jQuery('.pre-order-header.cart-icon .cart-count').text() == 'NaN') {
    //           jQuery('.pre-order-header.cart-icon .cart-count').text(0); 
    //         }
    //     }
    // });

    // jQuery('.pre-order-header.cart-icon .cart-count').on('DOMNodeInserted',function(){
    //     if(jQuery('.pre-order-header.cart-icon .cart-count').text() == 'NaN') {
    //       console.log(true);
    //       console.log(jQuery('.pre-order-header.cart-icon .cart-count').text());
    //         var cartTotalNumber = 0;
    //         if(jQuery('.header_container .cart .qtyinput').length){
    //             jQuery('.header_container .cart .qtyinput').each(function(){
    //                 cartTotalNumber += parseInt(jQuery(this).text());
    //             });
    //             jQuery('.pre-order-header.cart-icon .cart-count').text(cartTotalNumber);
    //         }
    //     }
    // });

    //set collapse section full-height on mobile
    if (jQuery('.collapse-toggle .collapse-block').length && jQuery(window).width() <= 767) {
        jQuery('.collapse-toggle .collapse-block').each(function(){
            var paddingSection = (jQuery(window).height() - jQuery(this).outerHeight()) / 2; 
            if (paddingSection > 0){
                //jQuery(this).closest('.collapse-toggle').css({'padding-top': paddingSection + 'px', 'padding-bottom': paddingSection + 'px'});  
            }
            
        })
        
    }


    // Hover show/hide first image and second image of feature products section when hover
    jQuery('.anyway-range-item .imgholder').mouseenter(function(){
         // if (jQuery(window).width() > 991) {
            // jQuery(this).addClass('hover');
         // }
    });

    jQuery('.anyway-range-item .imgholder').mouseleave(function(){
        // if (jQuery(window).width() > 991) {
          // jQuery(this).removeClass('hover');
        // }
    });

    // Hover show/hide first image and second image of feature products section when click on mobile
    jQuery('.anyway-range-item .imgholder').click(function(){
        // var element = jQuery(this);
        // if (jQuery(window).width() <= 991) {
            // window.location = element.find('a').attr('href');
        // } 
    });

  
    jQuery(window).on('hashchange', function() {
		if (location.hash == '#holiday-season-offer') {
            let headerHeight = 0;
            if (jQuery('#shopify-section-header').length){
                headerHeight = jQuery('#shopify-section-header').height();
            }
            let offerTop = jQuery('#section-holiday-season-offer').offset().top + headerHeight + 50;
            jQuery('html, body').animate({
                  scrollTop: offerTop
            }, 400, 'linear');
    		if(window.location.hash) {
			    history.pushState("", document.title, window.location.pathname + window.location.search);
			}
		}
	});
});



jQuery(window).on('load',function(){
  fullHeightMeatTheTeam();
});

  
jQuery(window).on('resize change orientation', function(){
//     windowOnChange = 1;
//     clearInterval(windowChangeTimeout);
//     var windowChangeTimeout = setTimeout(function(){
//         windowOnChange = 0;
//     }, 400);
    fullHeightMeatTheTeam();
    addSpacingTopMain();
});



jQuery(window).scroll(function(){
//   clearInterval(windowChangeTimeout);
  showHideHeader();
});